const meses = [
  "Enero",
  "Febrero",
  "Marzo",
  "Abril",
  "Mayo",
  "Junio",
  "Julio",
  "Agosto",
  "Septiembre",
  "Octubre",
  "Noviembre",
  "Diciembre"
];

export function formatIsoDate(
  isoDate: string,
  withSeconds = false,
  splitter = "T"
): string {
  try {
    if (!isoDate || !isoDate.trim || !isoDate.trim()) {
      return isoDate;
    }

    const [date, time] = isoDate.split(splitter);
    const [year, month, day] = date.split("-");

    if (!year || !month || !day) {
      return date;
    }

    // Formato de la fecha:
    const fmtDate = `${day}/${month}/${year}`;

    if (!time || !time.trim()) {
      return fmtDate;
    }

    if (!withSeconds) {
      const indexSeconds = time.lastIndexOf(":");
      const fmtTime =
        indexSeconds >= 4 ? time.substring(0, indexSeconds) : time;
      return fmtDate + " " + fmtTime;
    } else {
      const fmtTime = time.length > 8 ? time.substring(0, 8) : time;
      return fmtDate + " " + fmtTime;
    }
  } catch (error) {
    return isoDate;
  }
}

export function formatEnum(str: string): string {
  if (!str || !str.toLowerCase) {
    return "";
  }

  const sentence = str.toLowerCase().split("_");
  for (var i = 0; i < sentence.length; i++) {
    if (sentence[i]) {
      sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
    }
  }

  return sentence.join(" ").trim();
}

export function formatMoney(value: number, digits?: number): string {
  return new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: digits || 0
  }).format(normalizeNumber(value));
}

export function formatNumber(value: number, digits?: number): string {
  return new Intl.NumberFormat("es-MX", {
    minimumFractionDigits: digits || 0
  }).format(normalizeNumber(value));
}

export function formatPercent(value: number): string {
  return `${normalizeNumber(value).toFixed(2)}%`;
}

export function formatGroupBy<T, K extends PropertyKey>(
  array: T[],
  keySelector: (item: T) => K
): Record<K, T[]> {
  return array.reduce(
    (accum, item) => {
      const key = keySelector(item);
      accum[key] = accum[key] || [];
      accum[key].push(item);
      return accum;
    },
    {} as Record<K, T[]>
  );
}

export function formatGroupFirstBy<T, K extends PropertyKey>(
  array: T[],
  keySelector: (item: T) => K
): Record<K, T> {
  return array.reduce(
    (accum, item) => {
      const key = keySelector(item);
      const hasValue = key in accum;

      if (!hasValue) {
        accum[key] = item;
      }

      return accum;
    },
    {} as Record<K, T>
  );
}

function normalizeNumber(value: any): number {
  if (!value) {
    return 0;
  }

  const isNumber = !!value.toFixed;
  const numericValue = isNumber ? value : Number(value);

  return numericValue ? numericValue : 0;
}

export function formatPeriodo(isoDate: string): string {
  try {
    if (!isoDate || !isoDate.trim || !isoDate.trim()) {
      return isoDate;
    }

    const [date] = isoDate.split("T");
    const [year, month, day] = date.split("-");

    if (!year || !month || !day) {
      return date;
    }

    const monthIndex = parseInt(month, 10) - 1;
    const monthName = meses[monthIndex] || "";
    return `${monthName} ${year}`;
  } catch (error) {
    return isoDate;
  }
}
